<div class="content-card">
  <div class="header">
    <h2>{{ 'WP-Absences' | translate }}</h2>
  </div>
  <div class="filters-row">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'AbsenceType' | translate }}</mat-label>
      <mat-select [formControl]="filterTypeIds" multiple>
        @for (item of absenceTypes$ | async; track item.Id) {
        <mat-option [value]="item.Id">{{ item.Name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Status' | translate }}</mat-label>
      <mat-select [formControl]="filterStatusIds" multiple>
        @for (item of absenceStatuses$ | async; track item.Id) {
        <mat-option [value]="item.Id">{{ item.Name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <app-year-picker [year]="currentYear" (yearChange)="onYearChange($event)"></app-year-picker>
  </div>
  <div class="table-wrapper custom-table">
    @if (dataSource.loading$ | async) {
      <div class="loading-overlay">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
    <!-- Employment History's Table -->
    <mat-table #table matSort class="desktop" matSortActive="startDate" matSortDirection="desc" matSortDisableClear
      [dataSource]="(dataSource.absences$ | async) ?? []">
      <!-- Employer Column -->
      <ng-container matColumnDef="employer">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Employer' | translate }} <app-table-header-sort></app-table-header-sort></mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.Employer }}</mat-cell>
      </ng-container>
      <!-- EmployerObject Column -->
      <ng-container matColumnDef="employerObject">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'EmployerObject' | translate }} <app-table-header-sort></app-table-header-sort></mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.EmployerObject }}</mat-cell>
      </ng-container>
      <!-- Absence Type Column -->
      <ng-container matColumnDef="absenceType">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'AbsenceType' | translate }} <app-table-header-sort></app-table-header-sort></mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.AbsenceType }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="sentToApprovalOn">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'SentToApprovalOn' | translate }} <app-table-header-sort></app-table-header-sort></mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.SentToApprovalOn | date : 'yyyy-MM-dd HH:mm' }}</mat-cell>
      </ng-container>
      <!-- Start Date Column -->
      <ng-container matColumnDef="startDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'StartDate' | translate }} <app-table-header-sort></app-table-header-sort></mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.StartDate | date : 'yyyy-MM-dd' }}</mat-cell>
      </ng-container>
      <!-- End Date Column -->
      <ng-container matColumnDef="endDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'EndDate' | translate }} <app-table-header-sort></app-table-header-sort></mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.EndDate | date : 'yyyy-MM-dd' }}</mat-cell>
      </ng-container>
      <!-- Requested Days Column (part-time only) -->
      <ng-container matColumnDef="requestedDays">
        <mat-header-cell *matHeaderCellDef class="hidden-sort">
          {{ 'Absences.Profile.RequestedDaysColumn' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.RequestedDaysDisplay }}
        </mat-cell>
      </ng-container>
      <!-- Absence Days Column -->
      <ng-container matColumnDef="businessDays">
        <mat-header-cell *matHeaderCellDef mat-sort-header="BusinessTimeTicks" class="hidden-sort">
          {{ 'Absences.Profile.DaysColumn' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.BusinessDaysDisplay }}
          @if (element.BusinessTimeTicksChanged) {
          <div>
            <mat-icon
              [matTooltip]="'AbsenceValueChanged' | translate"
              matTooltipPosition="above"
              tabindex="0"
              [attr.aria-label]="('AbsenceValueChanged' | translate)"
            >
              update
            </mat-icon>
          </div>
          }
          @if (element.SpansMultipleWorkingTimePeriods) {
          <div>
            <mat-icon
              [matTooltip]="'ABS-MixedWorkingTimeDimensions' | translate"
              matTooltipPosition="above"
              tabindex="0"
              [attr.aria-label]="('ABS-MixedWorkingTimeDimensions' | translate)"
            >
              warning
            </mat-icon>
          </div>
          }
        </mat-cell>
      </ng-container>
      <!-- Absence Reason Column -->
      <ng-container matColumnDef="absenceReason">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'AbsenceReason' | translate }} <app-table-header-sort></app-table-header-sort></mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.AbsenceReason }}</mat-cell>
      </ng-container>
      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Status' | translate }} <app-table-header-sort></app-table-header-sort></mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.Status }}
          @if (shouldShowStatusTooltip(element)) {
          <div>
            <mat-icon [matTooltip]="getStatusTooltip(element)" matTooltipPosition="above">
              info
            </mat-icon>
          </div>
          }
        </mat-cell>
      </ng-container>
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef> {{ 'Actions' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (!element.SickLeaveId) {
          <div>
            @if (isConfirmAbsenceButtonVisible(element.StatusId, element.ApprovalRequired)) {
            <button mat-icon-button (click)="confirmAbsence(element.Id)" [disabled]="isActionInProgress">
              <mat-icon [matTooltip]="'ConfirmAbsence' | translate">check_circle</mat-icon>
            </button>
            }
            @if (isSendToApprovalButtonVisible(element.StatusId, element.ApprovalRequired)) {
            <button mat-icon-button (click)="sendToApproval(element.Id)" [disabled]="isActionInProgress">
              <mat-icon [matTooltip]="'SendToApproval' | translate">send</mat-icon>
            </button>
            }
            @if (approvingButtonsVisible(element)) {
            @if (isAcceptAbsenceButtonVisible(element.StatusId)) {
            <button mat-icon-button (click)="acceptAbsence(element.Id)"
              [visibleWithPermissions]="['AcceptWorkerAbsences', 'Supervisor']" [disabled]="isActionInProgress">
              <mat-icon [matTooltip]="'AcceptAbsence' | translate">thumb_up_alt</mat-icon>
            </button>
            }
            @if (isRejectAbsenceButtonVisible(element.StatusId)) {
            <button mat-icon-button (click)="rejectAbsence(element.Id)"
              [visibleWithPermissions]="['RejectWorkerAbsences', 'Supervisor']" [disabled]="isActionInProgress">
              <mat-icon [matTooltip]="'RejectAbsence' | translate">thumb_down_alt</mat-icon>
            </button>
            }
            }
            <button mat-icon-button (click)="openModal(element)" [disabled]="isActionInProgress"><mat-icon
                [matTooltip]="'EditAbsence' | translate">create</mat-icon></button>
            @if (isDeleteButtonVisible(element.StatusId)) {
            <button mat-icon-button (click)="deleteAbsence(element.Id)"
              [visibleWithPermissions]="['DeleteMyAbsences', 'DeleteWorkerAbsences']" [disabled]="isActionInProgress">
              <mat-icon [matTooltip]="'DeleteAbsence' | translate">delete</mat-icon>
            </button>
            }
            @if (isBackToDraftButtonVisible(element.StatusId)) {
            <button mat-icon-button (click)="backToDraftAbsence(element.Id)"
              [visibleWithPermissions]="['BackToDraftMyAbsences', 'BackToDraftWorkerAbsences']" [disabled]="isActionInProgress">
              <mat-icon [matTooltip]="'BackToDraftAbsence' | translate">cancel</mat-icon>
            </button>
            }
            @if (isCancelAbsenceButtonVisible(element.StatusId, element.AbsenceTypeId)) {
            <button mat-icon-button (click)="cancelAbsence(element.Id)"
              [visibleWithPermissions]="['CancelMyWorkersAbsences', 'CancelGlobalWorkersAbsences', 'Supervisor']" [disabled]="isActionInProgress">
              <mat-icon [matTooltip]="'CancelAbsence' | translate">reply</mat-icon>
            </button>
            }
          </div>
          } @else {
          <button
            [visibleWithPermissionsOnWorkerProfile]="['GetMyWorkerSickLeavesDetails', 'GetAllWorkerSickLeavesDetails']"
            [authServerUserId]="profile?.AuthServerUserId" mat-icon-button
            (click)="openSickLeaveDetailsModal(element.SickLeaveId)">
            <mat-icon>visibility</mat-icon>
          </button>
          }
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
    <mat-table #table matSort class="mobile" matSortActive="startDate" matSortDirection="desc" matSortDisableClear
      [dataSource]="(dataSource.absences$ | async) ?? []">
      <!-- Absence Type Column -->
      <ng-container matColumnDef="absenceType">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'AbsenceType' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.AbsenceType }}</mat-cell>
      </ng-container>
      <!-- Start Date Column -->
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'DateFromTo' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.StartDate | date : 'yyyy-MM-dd' }} - {{ element.EndDate | date :
          'yyyy-MM-dd' }}</mat-cell>
      </ng-container>
      <!-- Business Days Column -->
      <ng-container matColumnDef="businessDays">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Absences.Profile.DaysColumn' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.BusinessDaysDisplay }}
          @if (element.BusinessTimeTicksChanged) {
          <div>
            <mat-icon
              [matTooltip]="'AbsenceValueChanged' | translate"
              matTooltipPosition="above"
              tabindex="0"
              [attr.aria-label]="('AbsenceValueChanged' | translate)"
            >
              update
            </mat-icon>
          </div>
          }
          @if (element.SpansMultipleWorkingTimePeriods) {
          <div>
            <mat-icon
              [matTooltip]="'ABS-MixedWorkingTimeDimensions' | translate"
              matTooltipPosition="above"
              tabindex="0"
              [attr.aria-label]="('ABS-MixedWorkingTimeDimensions' | translate)"
            >
              warning
            </mat-icon>
          </div>
          }
        </mat-cell>
      </ng-container>
      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Status' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.Status }}</mat-cell>
      </ng-container>
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef> {{ 'Actions' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (isConfirmAbsenceButtonVisible(element.StatusId, element.ApprovalRequired)) {
          <button mat-icon-button (click)="confirmAbsence(element.Id)" [disabled]="isActionInProgress">
            <mat-icon [matTooltip]="'ConfirmAbsence' | translate">check_circle</mat-icon>
          </button>
          }
          @if (isSendToApprovalButtonVisible(element.StatusId, element.ApprovalRequired)) {
          <button mat-icon-button (click)="sendToApproval(element.Id)" [disabled]="isActionInProgress">
            <mat-icon [matTooltip]="'SendToApproval' | translate">send</mat-icon>
          </button>
          }
          @if (isAcceptAbsenceButtonVisible(element.StatusId)) {
          <button mat-icon-button (click)="acceptAbsence(element.Id)"
            [visibleWithPermissions]="['AcceptWorkerAbsences', 'Supervisor']" [disabled]="isActionInProgress">
            <mat-icon [matTooltip]="'AcceptAbsence' | translate">thumb_up_alt</mat-icon>
          </button>
          }
          @if (isRejectAbsenceButtonVisible(element.StatusId)) {
          <button mat-icon-button (click)="rejectAbsence(element.Id)"
            [visibleWithPermissions]="['RejectWorkerAbsences', 'Supervisor']" [disabled]="isActionInProgress">
            <mat-icon [matTooltip]="'RejectAbsence' | translate">thumb_down_alt</mat-icon>
          </button>
          }
          <button mat-icon-button (click)="openModal(element)" [disabled]="isActionInProgress"><mat-icon
              [matTooltip]="'EditAbsence' | translate">create</mat-icon></button>
          @if (isDeleteButtonVisible(element.StatusId)) {
          <button mat-icon-button (click)="deleteAbsence(element.Id)"
            [visibleWithPermissions]="['DeleteMyAbsences', 'DeleteWorkerAbsences']" [disabled]="isActionInProgress">
            <mat-icon [matTooltip]="'DeleteAbsence' | translate">delete</mat-icon>
          </button>
          }
          @if (isBackToDraftButtonVisible(element.StatusId)) {
          <button mat-icon-button (click)="backToDraftAbsence(element.Id)"
            [visibleWithPermissions]="['BackToDraftMyAbsences', 'BackToDraftWorkerAbsences']" [disabled]="isActionInProgress">
            <mat-icon [matTooltip]="'BackToDraftAbsence' | translate">cancel</mat-icon>
          </button>
          }
          @if (isCancelAbsenceButtonVisible(element.StatusId, element.AbsenceTypeId)) {
          <button mat-icon-button (click)="cancelAbsence(element.Id)"
            [visibleWithPermissions]="['CancelMyWorkersAbsences', 'CancelGlobalWorkersAbsences', 'Supervisor']" [disabled]="isActionInProgress">
            <mat-icon [matTooltip]="'CancelAbsence' | translate">reply</mat-icon>
          </button>
          }
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumnsMobile"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumnsMobile"></mat-row>
    </mat-table>
  </div>

  <mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"> </mat-paginator>
</div>